import api from '..';

export const getAnalystDataRequest = ({ type, forexFilter }) => {
  return api.get(`/economic-insight/analyst-data?type=${type}&filter=${forexFilter || 'all'}`);
};
